/* eslint-disable jsx-a11y/no-static-element-interactions */
'use client';

import { CardVideoInfo, Url } from '../types';
import CardVideo from '../card/CardVideo';
import ButtonLink from '../link/ButtonLink';
import TitleH2 from '../common/TitleH2';
import BorderedRectangle from '../icon/BorderedRectangle';
import Link from 'next/link';
import BorderedCircle from '../icon/BorderedCircle';
import { useRef, useState } from 'react';
import CustomCursor from '../cursor/CustomCursor';

interface GaleryProps {
  title: string;
  callToActionUrl: Url;
  cards: Array<CardVideoInfo>;
  imageFit?: 'cover' | 'none';
}

export default function GaleryVideoCarousel({ title, callToActionUrl, cards }: GaleryProps) {
  const [isHovering, setIsHovering] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const carouselRef = useRef<HTMLDivElement>(null);
  const [startX, setStartX] = useState(0);

  const handleMouseMoveCustomCursor = (e: React.MouseEvent<HTMLDivElement>) => {
    if (carouselRef.current) {
      const divTop = carouselRef.current.getBoundingClientRect().top;
      const relativeY = e.clientY - divTop;
      setIsHovering(relativeY > 312);
    }
  };

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    setMousePosition({ x: e.clientX, y: e.clientY });

    if (isDragging && carouselRef.current) {
      const x = e.pageX - carouselRef.current.offsetLeft;
      const walk = (x - startX) * 3;
      carouselRef.current.scrollLeft -= walk;
    }
  };

  const onMouseDown = (e: any) => {
    if (carouselRef.current) {
      setIsDragging(true);
      setStartX(e.pageX - carouselRef.current.offsetLeft);
    }
    e.preventDefault();
  };

  const onMouseUp = () => {
    setIsDragging(false);
  };
  const displayButton =
    callToActionUrl?.linkText !== '' &&
    (callToActionUrl?.slug !== '' || callToActionUrl?.url !== '')
      ? true
      : false;
  return (
    <div
      className="relative w-full px-4 bg-black-gradient-video bg-horizontal-gradient-video-bar video-gradient-bg md:mx-auto md:h-[700px] lg:px-0"
      onMouseMove={handleMouseMoveCustomCursor}
    >
      <div className="max-w-auto mx-auto flex py-7 md:py-12 lg:max-w-container lg:px-11">
        <div className="flex w-full items-center">
          <TitleH2 styles="grow" size="medium" customFont={true}>
            {!!title ? title : 'Videos'}
          </TitleH2>
          {displayButton && (
            <div className="hidden lg:flex">
              <ButtonLink
                name={callToActionUrl.linkText || ''}
                url={callToActionUrl}
                transparentBg={true}
                border={true}
                styles="text-white"
                buttonStyle="transparent_with_ball"
                buttonBallColor="white"
              />
            </div>
          )}
        </div>
      </div>
      <div className="relative flex w-full flex-col justify-center lg:ml-11">
        <div
          className="md:max-w-auto carousel carousel-center relative h-[500px] md:mx-auto md:flex-row md:gap-5 md:overflow-auto lg:max-w-container lg:cursor-none"
          onMouseLeave={() => setIsHovering(false)}
          onMouseDown={onMouseDown}
          onMouseMove={handleMouseMove}
          ref={carouselRef}
          onMouseUp={onMouseUp}
        >
          {cards.map((cardInfo, indexSlide) => {
            return (
              <div
                key={indexSlide}
                id={`videos-item${indexSlide + 1}`}
                className="carousel-item relative flex h-40 w-full flex-col md:w-[560px]"
              >
                <CardVideo {...cardInfo} type="default" />
                <div className="relative mt-[50px] flex w-full items-center justify-center gap-2 md:hidden md:w-auto">
                  {cards.map((_, index) => {
                    return (
                      <Link
                        key={index}
                        href={`#videos-item${index + 1}`}
                        target="_self"
                        title="Navigation videos"
                        onClick={(e) => {
                          // https://github.com/saadeghi/daisyui/issues/413
                          // TODO check later
                          if (document) {
                            const targetElement = document.getElementById(
                              `videos-item${index + 1}`,
                            );

                            targetElement?.scrollIntoView({
                              behavior: 'smooth',
                              // block: 'nearest',
                            });
                          }
                          // e.preventDefault();
                        }}
                      >
                        {indexSlide === index ? <BorderedRectangle /> : <BorderedCircle />}
                      </Link>
                    );
                  })}
                </div>
              </div>
            );
          })}
        </div>
        <div className="mb-10 flex w-full items-center justify-center md:hidden">
          <ButtonLink
            name="Découvrez toutes les vidéos"
            url={{ url: '', external: false, linkText: 'Découvrez toutes les vidéos' }}
            transparentBg={true}
            styles="text-white font-bold"
            textSize="text-sm"
          />
        </div>
      </div>
      {isHovering && (
        <CustomCursor text="Déplacer" mouseX={mousePosition.x} mouseY={mousePosition.y} />
      )}
    </div>
  );
}
